import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import GamePage from './pages/GamePage.jsx';
import GamePageOR from './pages/GamePageOR.jsx';
import GamePageKI from './pages/GamePageKI.jsx';
import GamePageSO from './pages/GamePageSO.jsx';
import GamePageTG from './pages/GamePageTG.jsx';
import Home from './pages/Home.jsx';
import InDevelopment from './pages/InDevelopment.jsx';
import AboutUs from './pages/AboutUs.jsx';
// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
    <Router>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/GamePage' element={<GamePage />} />
            <Route path='/GamePageOR' element={<GamePageOR />} />
            <Route path='/GamePageKI' element={<GamePageKI />} />
            <Route path='/GamePageSO' element={<GamePageSO />} />
            <Route path='/GamePageTG' element={<GamePageTG />} />
             <Route path="/in-development" element={<InDevelopment />} />
             <Route path="/about-us" element={<AboutUs />} />
          </Routes>
      </Router>
    </>
  );
}

export default App;
